export default {
    slug: 'vouchers/templates',
    title: 'Voucher Templates',
    visible: [
        'id',
        'title'
    ],
    listview: 'VoucherTemplatesListView',
    locales: ['common'],
    columns: [],
    templates: {},
    actions: {
        details: {
            title: 'Details',
            level: 'row',
            vm: 'goToDetails'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/vouchers/templates/state.js